/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Platform_Header_FromInputs */

const en_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From · ${i?.action}`)
};

const zh_hans1_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`起价 · ${i?.action}`)
};

const pt_br2_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A partir de · ${i?.action}`)
};

const es_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde · ${i?.action}`)
};

const fr_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À partir de · ${i?.action}`)
};

const de_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab · ${i?.action}`)
};

const ru_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`От · ${i?.action}`)
};

const it_platform_header_from = /** @type {(inputs: Platform_Header_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Da · ${i?.action}`)
};

/**
* | output |
* | --- |
* | "From · {action}" |
*
* @param {Platform_Header_FromInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_header_from = /** @type {((inputs: Platform_Header_FromInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Header_FromInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_header_from(inputs)
	if (locale === "pt-BR") return pt_br2_platform_header_from(inputs)
	if (locale === "es") return es_platform_header_from(inputs)
	if (locale === "fr") return fr_platform_header_from(inputs)
	if (locale === "de") return de_platform_header_from(inputs)
	if (locale === "ru") return ru_platform_header_from(inputs)
	if (locale === "it") return it_platform_header_from(inputs)
	return en_platform_header_from(inputs)
});